import React, { useState } from "react";
import { withRouter, Link } from "react-router-dom";

import { connect } from "react-redux";
import logo from "assets/img/compliancy-group-logo.png";
import Button from "components/Button/Button";
import styles from "./Login.module.scss";
import WelcomePanel from "../components/WelcomePanel/WelcomePanel";
import FormElement from "components/FormElement/FormElement";
import InputAdornment from "components/InputAdornment/InputAdornment";
import { submitUserLoginFormAction, submitUserForgotPasswordAction } from "store/actions/Actions";
import { showPassword } from "helpers/utils";

const Login = props => {
    const [state, setState] = useState({ user: '', pass: '' });
    const [stateErrors, setStateErrors] = useState({});
    const [togglePasswordIcon, setTogglePasswordIcon] = useState(false)

    const handleChange = (inputName) => (e) => {
        e.persist();
        setState((s) => ({
            ...s,
            [inputName]:
                e.target.type === "checkbox"
                    ? e.target.checked : e.target.value === "true" ? true
                    : e.target.value === "false" ? false : e.target.value
        }));
        if (e.target.value === '' && inputName === 'user') {
            setStateErrors((s) => ({ ...s, user: 'Email is required!' }));
        }
        if (e.target.value === '' && inputName === 'pass') {
            setStateErrors((s) => ({ ...s, pass: 'Password is required!' }));
        }
        if (e.target.value !== '') {
            setStateErrors((s) => ({ ...s, [inputName]: '' }));
        }
    };

    const handleLogin = () => {
        try {
            if (state.user === "" || state.pass === "") {
                if (state.user === "") {
                    setStateErrors((s) => ({ ...s, user: 'Email is required!' }));
                }
                if (state.pass === "") {
                    setStateErrors((s) => ({ ...s, pass: 'Password is required!' }));
                }
            } else {
                props.submitUserLoginFormAction({
                    email: state.user,
                    password: state.pass,
                    redirect: props.match.params.hash
                });
            }
        } catch (error) {
            console.log('error submiting login form!', error);
        }
    };

    const toggleShowPassword = (isPasswordVisible) => {
        setTogglePasswordIcon(isPasswordVisible);
        showPassword('pass-login', isPasswordVisible)
    }

    return (
        <WelcomePanel type="login">
                <div className={styles["login-panel-heading"]}>
                    <img className={styles.logo} src={logo} alt="" />
                </div>

                <div className={styles["login-panel-content"]}>
                    <p className={styles.welcome}>Welcome to The Guard!</p>
                    <FormElement
                        htmlFor="user"
                        errorMessage={stateErrors.user}
                    >
                        <InputAdornment iconStart="fal fa-at">
                            <input
                                onChange={handleChange("user")}
                                type="text"
                                placeholder="E-mail"
                                name="user"
                                value={state.username}
                                id="user-login"
                            />
                        </InputAdornment>
                    </FormElement>
                    <FormElement
                        htmlFor="pass"
                        errorMessage={stateErrors.pass}
                    >
                        <InputAdornment iconStart="fal fa-lock-alt">
                            <input
                                onChange={handleChange("pass")}
                                type="password"
                                // autoComplete="off"
                                placeholder="Password"
                                name="pass"
                                value={state.pass}
                                className={styles.password}
                                id="pass-login"
                            />
                            <span className={styles['show-password']}>
                                <button
                                    className={styles['password-button']}
                                    onClick={() => toggleShowPassword(!togglePasswordIcon)}>
                                    <i 
                                        className={togglePasswordIcon ? 'hide' : 'fas fa-eye'}
                                        title="show password"></i>
                                    <i 
                                        className={!togglePasswordIcon ? 'hide' : 'fas fa-eye-slash'}
                                        title="hide password"></i>
                                </button>
                            </span>
                        </InputAdornment>
                    </FormElement>

                    <Link to="/login/forgot-password">
                        Forgot your username and/or password?
                    </Link>

                    <br />

                </div>

                <div className={styles["login-panel-footer"]}>
                    <Button text={"CLICK TO LOGIN"} onClick={handleLogin} />
                </div>
        </WelcomePanel>
    )
};

const mapStateToProps = state => ({});

const mapDispatchToProps = {
    submitUserLoginFormAction,
    submitUserForgotPasswordAction,
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(Login));
